import React from "react";
import { Link, Navigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";

const AdminBlogLayout = ({ title, action, children }) => {
  const { admin, checking, logout } = useAuth();
  if (checking) return <div className="pt-32 text-center font-mono text-zinc-500 uppercase">Authenticating...</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;

  return (
    <main className="min-h-screen bg-cynos-bg" data-testid="admin-blog-page">
      <header className="border-b border-white/10 bg-black px-4 md:px-8 py-4 flex items-center justify-between sticky top-0 z-30">
        <div className="flex items-center gap-6">
          <Link to="/admin" className="font-anton text-2xl uppercase">CYNOS<span className="text-cynos-red">.</span></Link>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Admin Blog</span>
        </div>
        <button onClick={logout} className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] hover:text-cynos-red">
          <LogOut size={14} /> Logout
        </button>
      </header>
      <div className="px-4 md:px-8 py-8">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <Link to="/admin" className="font-mono text-xs uppercase tracking-[0.2em] text-cynos-red">Back to Dashboard</Link>
            <h1 className="mt-3 font-anton text-5xl uppercase">{title}</h1>
          </div>
          {action}
        </div>
        {children}
      </div>
    </main>
  );
};

export default AdminBlogLayout;
